/**
 * Offline utility functions
 * All operations in this app work offline - this file provides helpers for offline detection
 */

/**
 * Check if the app is currently online
 */
export function isOnline(): boolean {
  return navigator.onLine
}

/**
 * Get offline status with a callback for changes
 */
export function useOfflineStatus(
  callback: (isOnline: boolean) => void
): () => void {
  const handleOnline = () => callback(true)
  const handleOffline = () => callback(false)

  window.addEventListener('online', handleOnline)
  window.addEventListener('offline', handleOffline)

  // Initial state
  callback(navigator.onLine)

  // Return cleanup function
  return () => {
    window.removeEventListener('online', handleOnline)
    window.removeEventListener('offline', handleOffline)
  }
}

/**
 * Verify that IndexedDB is available (works offline)
 */
export async function verifyIndexedDBAvailable(): Promise<boolean> {
  if (!('indexedDB' in window)) {
    console.error('IndexedDB is not available')
    return false
  }
  return true
}

/**
 * Verify that MediaRecorder is available (works offline)
 */
export function verifyMediaRecorderAvailable(): boolean {
  if (!('MediaRecorder' in window)) {
    console.error('MediaRecorder is not available')
    return false
  }
  return true
}

